// Centralised test ids for the CoVerify landing page.
export const TID = {
  // Header
  headerLogo: "header-logo",
  navFeatures: "nav-features",
  navPersonas: "nav-personas",
  navFlow: "nav-flow",
  navDemo: "nav-demo",
  navFaq: "nav-faq",
  navBookDemo: "nav-book-demo",
  mobileMenuToggle: "mobile-menu-toggle",
  // Hero
  heroStartVerification: "hero-start-verification",
  heroContactSales: "hero-contact-sales",
  // Personas
  personaAccountants: "persona-accountants",
  personaCoSec: "persona-co-sec",
  personaLegal: "persona-legal",
  // Key Features Tabs
  featureTab: (k) => `feature-tab-${k}`,
  // Verification flow
  flowStep: (i) => `flow-step-${i}`,
  // Live demo
  demoLaunchBtn: "demo-launch-button",
  demoCloseBtn: "demo-close-button",
  demoStatus: "demo-status-text",
  demoMountContainer: "coverify-mount",
  // FAQ
  faqItem: (i) => `faq-item-${i}`,
  // Footer
  footerContact: "footer-contact-link",
  footerCosecLink: "footer-cosec-link",
};
